import type TauriDatabase from "@tauri-apps/plugin-sql";
import { type Database as BunDatabase } from "bun:sqlite";

import { type SqliteTableDef } from "../schema";
import { createTableSql } from "./createTableSql";

/**
 * Creates a table in the database using the provided table definition.
 * @param db The database connection (either Bun's SQLite or Tauri's SQL plugin)
 * @param tableDef The table definition to create
 * @param ifNotExists Whether to add IF NOT EXISTS to the CREATE TABLE statement
 */
export async function runCreateTable(
	db: BunDatabase | TauriDatabase,
	tableDef: SqliteTableDef,
	ifNotExists: boolean = false
): Promise<void> {
	const { statement, params } = createTableSql(tableDef, ifNotExists);

	if ("prepare" in db) {
		db.prepare(statement, params).run();
	} else {
		await db.execute(statement, params);
	}
}
